import React, { useState } from "react"

const EditableCell = ({

  value: initialValue,

  row: { index, original },

  column: { id },

  updateMethod, // This is a custom function that we supplied to our table instance
  deleteChange

}) => {

  // We need to keep and update the state of the cell normally
  const status_id = original.statusEnum || original.status;
  // const status_id = original.status_id  || original.statusId || original.statusEnum;
  const [value, setValue] = useState(initialValue);
  const [state, setState] = useState('value-ori');

  const onChange = e => {
    setValue(e.target.value)
    if (!e.target.value) {
      setState('value-init');
      setValue(initialValue);
      deleteChange(index, id);

    } else if (e.target.value.indexOf('.') >= 0 && e.target.value.substr(e.target.value.indexOf('.')).length > 3){
      setState('value-error');
      deleteChange(index, id);
    } else {
      setState('value-update');
      updateMethod(index, id, e.target.value);
    }
  }

  const unauthorized = (status) => {
    if (status.includes( "B") || status.includes("K")) {
      return false
    }
    return true
  }

  // const unauthorized = (status) => {
  //   if (status < 7) {
  //     return false
  //   }
  //   return true
  // }

  // If the initialValue is changed external, sync it up with our state

  React.useEffect(() => {

    setValue(initialValue)

  }, [initialValue])

  return <input type="number" min="0" step=".01" value={value} onChange={onChange} className={`${state} zahl-input`} disabled={unauthorized(status_id)}/>

}

export default EditableCell
